<template>
  <div class="text-xs-center">
    <v-dialog v-model="dialog" width="500" persistent>
      <v-card>
        <v-card-title class="primary modal-title">
          Tipo de Documento
        </v-card-title>

        <v-card-text v-if="multiplo">
          Selecione o tipo de documento para os arquivos anexados.
        </v-card-text>
        <v-card-text v-else>
          Selecione o tipo de documento para o arquivo anexado.
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" @click="$emit('proposta')">
            Proposta
          </v-btn>
          <v-spacer></v-spacer>
          <v-btn color="primary" @click="$emit('habilitacao')">
            Habilitação
          </v-btn>
          <v-spacer></v-spacer>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
export default {
  name: 'SelecionarTipoDocumento',
  props: ['dialog', 'multiplo']
}

</script>